import { IPublicTypePageSchema, IPublicTypeComponentSchema, IPublicTypeBlockSchema } from './';

/**
 * @todo
 */
// eslint-disable-next-line max-len
export type IPublicTypeRootSchema = IPublicTypePageSchema | IPublicTypeComponentSchema | IPublicTypeBlockSchema;
